import { useEffect } from "react";
import { toast } from "sonner";
import { useIsMobile } from "@/hooks/use-mobile";

export function WelcomeBackToast() {
  const isMobile = useIsMobile();

  useEffect(() => {
    if (!isMobile) return;

    const visits = localStorage.getItem("site_visits");
    const lastVisitDate = localStorage.getItem("last_visit_date");
    
    // Store current visit
    const today = new Date().toDateString();
    
    if (!visits) {
      // First time visitor
      localStorage.setItem("site_visits", "1");
      localStorage.setItem("last_visit_date", today);
      return;
    }

    // Only show once per day
    if (lastVisitDate !== today) {
      const visitCount = parseInt(visits) + 1;
      localStorage.setItem("site_visits", visitCount.toString());
      localStorage.setItem("last_visit_date", today);

      // Delay slightly for better UX
      setTimeout(() => {
        toast.success("Welcome back!", {
          description: "Ready to get your home sparkling clean today?",
          position: "top-center",
          duration: 4000,
        });
      }, 2000);
    }
  }, [isMobile]);

  return null;
}
